// @flow
import spacing from './constants/spacing'
import type { SpacingSize } from './constants/spacing'

const padding = (size: SpacingSize) => ({ padding: spacing(size) })
padding.top = (size: SpacingSize) => ({ paddingTop: spacing(size) })
padding.right = (size: SpacingSize) => ({ paddingRight: spacing(size) })
padding.bottom = (size: SpacingSize) => ({ paddingBottom: spacing(size) })
padding.left = (size: SpacingSize) => ({ paddingLeft: spacing(size) })
padding.x = (size: SpacingSize) => ({
  paddingLeft: spacing(size),
  paddingRight: spacing(size),
})
padding.y = (size: SpacingSize) => ({
  paddingTop: spacing(size),
  paddingBottom: spacing(size),
})

export default padding



// WEBPACK FOOTER //
// ./src/style/padding.js